'use strict';

filter.$inject = ["FilterCategory", "FilterCategoryItem", "Enums", "$state", "$stateParams", "queryStringHelper"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filter = filter;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filter(FilterCategory, FilterCategoryItem, Enums, $state, $stateParams, queryStringHelper) {
    var clazz = function Filter() {
        var defaults = {
            filterCategories: [],
            flatListsOfCategories: [],
            selectedFilters: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {

        // Used when clearing a filter
        getParentIdOfChildCategory: function getParentIdOfChildCategory(categoryTypeId, id) {
            var flatList = _lodash2.default.find(this.flatListsOfCategories, { key: categoryTypeId }).list;
            var item = _lodash2.default.find(flatList, function (i) {
                return i.Id === id;
            });
            return item ? item.ParentId : null;
        },

        markFilterCheckboxesAsSelected: function markFilterCheckboxesAsSelected(qsFilter) {
            for (var i = 0; i < this.filterCategories.length; i++) {
                var filterCategory = this.filterCategories[i];
                var selectedIds = queryStringHelper.getSelectedIdsFromQueryString(qsFilter, filterCategory.id);
                var item = null;

                //category 
                if (!filterCategory.isHierarchical && !filterCategory.isLink) {
                    for (var j = 0; j < filterCategory.items.length; j++) {
                        item = filterCategory.items[j];
                        item.isSelected = selectedIds ? selectedIds.indexOf(item.id) >= 0 : false;
                    }
                } else if (!filterCategory.isLink) {
                    if (selectedIds) {
                        //find each category by id and select it
                        selectedIds.forEach(function (selectedCategoryId) {
                            for (var _j = 0; _j < filterCategory.items.length; _j++) {
                                item = filterCategory.items[_j];

                                // select the children and the parent
                                if (item.children && item.children.length > 0 && item.id !== selectedCategoryId) {
                                    item.children.forEach(function (child) {
                                        if (child.id === selectedCategoryId) {
                                            child.isSelected = true;
                                            item.isSelected = true;
                                        }
                                        child.children.forEach(function (child1) {
                                            if (child1.id === selectedCategoryId) {
                                                child1.isSelected = true;
                                                child.isSelected = true;
                                                item.isSelected = true;
                                            }
                                        });
                                    });
                                } else if (item.id === selectedCategoryId) {
                                    item.isSelected = true;
                                } else {
                                    item.isSelected = false;
                                }
                            }
                        });
                    } else {
                        //if there are no selected id's, make sure they are all unchecked
                        filterCategory.items.forEach(function (filterCategoryItem) {
                            if (filterCategoryItem.children) {
                                filterCategoryItem.children.forEach(function (child) {
                                    child.isSelected = false;
                                });
                            }
                            filterCategoryItem.isSelected = false;
                        });
                    }
                }
            }
        },

        setSelectedFilters: function setSelectedFilters(qsFilter) {
            var selectedFilters = [];

            for (var i = 0; i < this.filterCategories.length; i++) {
                var filterCategory = this.filterCategories[i];
                var selectedFilterCategory = filterCategory.isHierarchical ? this.getSelectedItemsForHierarchicalFilterCategory(filterCategory, qsFilter) : this.getSelectedItemsForNonHierarchicalFilterCategory(filterCategory);

                //filter out category and product range filters, because they cannot be shown in the current filter bar
                if (selectedFilterCategory && String(selectedFilterCategory.id) !== String(Enums.categoryType.category.id) && String(selectedFilterCategory.id) !== String(Enums.categoryType.productRange.id)) {
                    selectedFilters.push(selectedFilterCategory);
                }
            }
            this.selectedFilters = selectedFilters;
        },

        // for non-hierarchical filters: get the selected items from the list
        getSelectedItemsForNonHierarchicalFilterCategory: function getSelectedItemsForNonHierarchicalFilterCategory(filterCategory) {
            var selectedItems = _lodash2.default.chain(filterCategory.items).filter({ isSelected: true }).map(function (item) {
                return { id: item.id, name: item.name };
            }).value();

            return selectedItems.length === 0 ? null : { id: filterCategory.id, name: filterCategory.name, items: selectedItems };
        },

        // for hierarchical filters: get the name of the item that corresponds with the query string param, and all of its parents
        getSelectedItemsForHierarchicalFilterCategory: function getSelectedItemsForHierarchicalFilterCategory(filterCategory, qsFilter) {
            var selectedIds = queryStringHelper.getSelectedIdsFromQueryString(qsFilter, filterCategory.id);
            var selectedCategoryId = selectedIds && selectedIds.length > 0 ? selectedIds[0] : null;
            if (!selectedCategoryId) {
                return null;
            }

            var flatList = _lodash2.default.find(this.flatListsOfCategories, { key: filterCategory.id }).list;

            var selectedCategories = [];
            selectedIds.forEach(function (selectedId) {
                var category = _lodash2.default.find(flatList, { id: selectedId });
                if (category) {
                    selectedCategories.push(category);
                }
            });

            return { id: filterCategory.id, name: filterCategory.name, items: selectedCategories };
        },

        clearFilter: function clearFilter(categoryId, filterId) {
            var filterCategory = _lodash2.default.find(this.filterCategories, { id: categoryId });
            if (!filterCategory) {
                return;
            }

            var item = _lodash2.default.find(filterCategory.items, { id: filterId });
            if (!item) {
                return;
            }

            item.isSelected = false;
        },

        isCategoryHierarchical: function isCategoryHierarchical(categoryId) {
            var filterCategory = _lodash2.default.find(this.filterCategories, { id: categoryId });
            return filterCategory && filterCategory.isHierarchical;
        }
    });

    clazz.create = function (resource) {
        var filter = new clazz();
        if (resource.categories && resource.categories.length > 0) {
            _lodash2.default.forEach(resource.categories, function (category) {
                var filterCategory = FilterCategory.create(category);

                //list of categories used in the views$
                filter.filterCategories.push(filterCategory);

                //flatlist of categories used for searches
                if (filterCategory.isSellerCategory || !filterCategory.isSellerCategory && category.id === Enums.categoryType.category.id) {
                    filter.flatListsOfCategories.push({ key: filterCategory.id, list: category.items });
                }
            });
        }

        // set discount only
        if (resource.showDiscountsOnlyOption) {
            var discountsOnlyFilter = FilterCategory.createShowDiscountsOnly();

            //order the discount filter after the items with position 2
            var elementPos = filter.filterCategories.map(function (x) {
                return x.order;
            }).indexOf(2);

            //if position 2 does not exist add it to the end of the array
            elementPos === -1 ? filter.filterCategories.push(discountsOnlyFilter) : filter.filterCategories.splice(elementPos, 0, discountsOnlyFilter);
        }

        //if the state is brand, order the categories
        if ($state.current.name === 'brand') {
            var temp = [filter.filterCategories[1], filter.filterCategories[2], filter.filterCategories[0]];
            filter.filterCategories = temp;
        }

        return filter;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/filterModel.js
// module id = 751
// module chunks = 0